import React from "react";
import "./testimonial.css";
import productsIcon from "./images/project.webp";
import clientsIcon from "./images/team.webp";
import projectsIcon from "./images/docs.webp";
import testimonialImg from "./images/engineer.webp";



function TestimonialsAndStats() {
  return (
    <div>

      {/* Testimonials Section */}
      <section className="testimonial-section">
        <h2 className="testimonial-title">TESTIMONIALS</h2>
        <div className="testimonial-content">
          <img src={testimonialImg} alt="Testimonial" className="testimonial-img" />
          <div className="testimonial-text">
            <p>
              SITE-EXIT provided an efficient and reliable solution for our construction site access needs. The product quality, timely support, and overall professionalism exceeded our expectations. Their system helped improve site cleanliness, reduce maintenance efforts, and streamline daily operations.

            </p>
            <h4 className="testimonial-author">Michael Carter - <span>Project Manager</span></h4>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TestimonialsAndStats;
